module.exports = __webpack_public_path__ + "img/klaviyoSegment.b5fe6104.svg";